<div class="chip-list">
  <div class="chip" *ngFor="let chip of chips" >
    <span class="chip-text">{{chip.value}}</span>
    <button class="chip-remove" (click)="onRemoveChip(chip)">&times;</button>
  </div>
</div>
